var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4392 0.59474C15.6631 -0.191261 14.3968 -0.199317 13.6108 0.576748L0.802208 13.2234C0.0162077 13.9995 0.00815201 15.2658 0.784217 16.0518C1.56028 16.8378 2.82659 16.8459 3.61259 16.0698L14.998 4.8283L26.2395 16.2137C27.0156 16.9997 28.2819 17.0078 29.0679 16.2317C29.8539 15.4557 29.862 14.1894 29.0859 13.4034L16.4392 0.59474ZM17 4.53176L17.016 2.01265L13.0161 1.98721L13 4.50632L17 4.53176Z",
    fill: "#7C838A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpNormal);
export default __webpack_public_path__ + "static/media/arrow-up-normal.fe968e022dd6d992628d95aecdd9dac5.svg";
export { ForwardRef as ReactComponent };